export const DEFAULT_MAX_RATE = 10;

export function normalizeMaxRate(value: unknown): number {
  const maxRate = Number(value);
  return maxRate === 5 || maxRate === 10 ? maxRate : DEFAULT_MAX_RATE;
}

export function clampRating(value: unknown, maxRate: unknown): number {
  const normalizedMaxRate = normalizeMaxRate(maxRate);
  const rating = Math.floor(Number(value));
  const normalizedRating = Number.isFinite(rating) ? rating : 1;

  return Math.min(Math.max(normalizedRating, 1), normalizedMaxRate);
}

export function normalizeRatingValues(
  maxRate: unknown,
  rateIn: unknown,
  rateOut: unknown
) {
  const normalizedMaxRate = normalizeMaxRate(maxRate);
  const normalizedRateIn = clampRating(rateIn, normalizedMaxRate);

  return {
    maxRate: normalizedMaxRate,
    rateIn: normalizedRateIn,
    rateOut: Math.min(clampRating(rateOut, normalizedMaxRate), normalizedRateIn),
  };
}
